<app-partner-registration #partnerComponent [partner]="partner" [showPassword]="true"
  [showOldPasswordConfirmation]="true" [password]="password" [showRepeatEmail]="false" [showEmailAgree]="false"
  [showAGBAgree]="false" (eventRegistrationDataValid)="editDataValid()"
  (eventRegistrationDataInvalid)="editDataInvalid()" (eventRegistrationDataDirty)="editDataDirty()"
  (eventRegistrationDataNotDirty)="editDataNotDirty()" [title]="'Personal Data' | translate"
  [description]="'Change your personal information'| translate"></app-partner-registration>
<div class="row">
  <div class="col-12 error">
    <p *ngIf='error'>{{ error | translate }}</p>
  </div>
</div>
<div class="row">
  <div class="col-12 col-md-5 mb-md-4">
    <!-- <app-button [title]="'Abort' | translate" [isLeftStyle]="true" (click)="onAbort()"></app-button> -->
  </div>
  <div class="col-12 col-md-5 offset-md-2">
    <app-button [title]="'Save' | translate" (clickEvent)="onSave()" [disabled]="!isSaveEnabled"></app-button>
  </div>
  <div class="col-12 col-md-3 remove-account-btn">
    <app-button [title]="'Remove account' | translate" [buttonCssClass]="'button button-left button-red'"
      (clickEvent)="onRemoveAccount()"></app-button>
  </div>
</div>
